import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { BaseRouteGuard } from './base.route-guard';

@Injectable({
    providedIn: 'root'
})
export class DraftContentRouteGuard extends BaseRouteGuard implements CanActivate, CanLoad {
    private readonly draftEnabled: boolean;
    private readonly myContentPageEnabled: boolean;

    constructor(
        capabilitiesService: CapabilitiesService,
        router: Router
    ) {
        super(router, capabilitiesService);
        this.myContentPageEnabled = this.capabilitiesService.capabilities.myContentEnabled;
        this.draftEnabled = this.capabilitiesService.capabilities.draftEnabled;
    }

    public canActivate() {
        return this.checkEnabledAndRedirect(this.myContentPageEnabled && this.draftEnabled);
    }

    public canLoad() {
        return this.checkEnabledAndRedirect(this.myContentPageEnabled && this.draftEnabled);
    }
}
